//import { useState } from 'react';
import './App.css';

function NoPage() {
    return (
        <div className="App">
            <h1>404 Not Found</h1>
            <p>This page does not exist.</p>
            <img src="https://media.giphy.com/media/3o7aD22a3b1z9e4xqY/giphy.gif" alt="Not Found gif" /><br />
        </div>
    );
}

export default NoPage;